// extracted by mini-css-extract-plugin
module.exports = {"container":"ChooseOfferButton_container__ek_XL","button":"ChooseOfferButton_button__H_iZM","description":"ChooseOfferButton_description__BZYkd"};